/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  RESET_USER_ORDER_BOOK,
  FETCH_USER_ORDER_BOOK_FAILURE,
  FETCH_USER_ORDER_BOOK_REQUEST,
  FETCH_USER_ORDER_BOOK_SUCCESS,
  UPDATE_USER_ORDER_BOOK_RETRY_AFTER_TIMER,
  USER_ORDER_BOOK_LIST_CACHE,
  USER_ORDER_BOOK_LIST_UPDATE_FILTERS,
  USER_ORDER_BOOK_LIST_SORTING,
} from '../../constants/ActionTypes';
import { readBuffer } from '../../utils';
import storage from '../../storage';

export const USER_ORDER_BOOK_TABLE_SORT = 'USER_ORDER_BOOK_TABLE_SORT';
export const USER_ORDER_BOOK_TABLE_FILTER = 'USER_ORDER_BOOK_TABLE_FILTER';
export const USER_ORDER_BOOK_TABLE_POSITION_STATE =
  'USER_ORDER_BOOK_TABLE_POSITION_STATE';

const getFilterFromStorage = () =>
  readBuffer(USER_ORDER_BOOK_TABLE_FILTER) || {};
const getSortFromStorage = () =>
  storage.getItem(USER_ORDER_BOOK_TABLE_SORT) || {};

function getListDefaultData() {
  return {
    data: {},
    retryAfter: undefined,
    combinedData: [],
    dataCached: [],
    filters: getFilterFromStorage(),
    updateTime: new Date(),
    cacheUpdateTime: new Date(),
    filtersUpdateTime: new Date(),
    sorting: getSortFromStorage(),
    error: null,
    brokerError: null,
  };
}

const list = (
  state = {
    ...getListDefaultData(),
  },
  action
) => {
  switch (action.type) {
    case FETCH_USER_ORDER_BOOK_REQUEST:
      return { ...state, isFetching: true, error: null };
    case FETCH_USER_ORDER_BOOK_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        data: action.data.data,
        combinedData: action.combinedData,
        updateTime: new Date(),
      };
    case FETCH_USER_ORDER_BOOK_FAILURE:
      return { ...state, isFetching: false, error: action.error };
    case UPDATE_USER_ORDER_BOOK_RETRY_AFTER_TIMER:
      return { ...state, retryAfter: action.data, isFetching: false };
    case USER_ORDER_BOOK_LIST_CACHE:
      return {
        ...state,
        dataCached: action.data,
        cacheUpdateTime: new Date(),
      };
    case USER_ORDER_BOOK_LIST_UPDATE_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.data,
        },
        filtersUpdateTime: new Date(),
      };
    case USER_ORDER_BOOK_LIST_SORTING:
      return {
        ...state,
        sorting: action.data,
      };
    case RESET_USER_ORDER_BOOK:
      return { ...state, ...getListDefaultData() };
    default:
      return state;
  }
};

const userOrderBook = combineReducers({
  list,
});

export default userOrderBook;
